export const GET_PRICING_CURRENCIES = "GET_PRICING_CURRENCIES";
export const GET_PRICING_CURRENCY_BY_ID = "GET_PRICING_CURRENCY_BY_ID";
export const UPDATE_PRICING_CURRENCY = "UPDATE_PRICING_CURRENCY";
export const DELETE_PRICING_CURRENCY = "DELETE_PRICING_CURRENCY";
export const CREATE_PRICING_CURRENCY = "CREATE_PRICING_CURRENCY";
